module.exports = __webpack_public_path__ + "addfiles.5f4640b6.svg";